import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import SiteExtras from "./SiteExtras";

export default function Layout() {
  return (
    <SiteExtras>
      <div className="min-h-screen flex flex-col bg-[#050814]">
        <Navbar />
        <main className="flex-1 dl-main-with-message">
          <Outlet />
        </main>
        <Footer />
      </div>
    </SiteExtras>
  );
}
